<template>
   <div v-show="show" class="bullet-loading">
       <div class="bullet-loading-box">
           <div class="brand-logo">
               <img v-if="$page.props.configs.companyLogo" :src="$page.props.configs.companyLogo" alt="logo">
           </div>

           <div class="loader-bullets">
               <i class="loader-bullet loader-bullet-1"/>
               <i class="loader-bullet loader-bullet-2"/>
               <i class="loader-bullet loader-bullet-3"/>
               <i class="loader-bullet loader-bullet-4"/>
           </div>
       </div>
   </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    props: ['show'],
})
</script>